import styled from 'styled-components';

import type { Color, Size as ThemeSize } from '../../../style/types/theme';
import { Size } from '../types';
import { Image } from '../Common.styled';

const getSize = (size: Size, themeSize: ThemeSize) => {
  switch (size) {
    case Size.XS:
      return themeSize.units(2);
    case Size.S:
      return themeSize.units(3);
    case Size.M:
      return themeSize.units(4);
    case Size.L:
      return themeSize.units(5);
    case Size.XL:
      return themeSize.units(8);
    case Size.XXL:
      return themeSize.units(10);
    case Size.XXXL:
      return themeSize.units(16);
    default:
      return themeSize.units(4);
  }
};

const getBoxShadow = (themeSize: ThemeSize, themeColor: Color, size?: Size): string => {
  switch (size) {
    case Size.XS:
      return `inset 0px 0px 0px 1px ${themeColor.shadow.secondary.default()}`;
    case Size.S:
      return `inset 0px 0px 0px ${themeSize.units(
        0.25,
      )} ${themeColor.shadow.secondary.default()}`;
    case Size.M:
      return `inset 0px 0px 0px ${themeSize.units(
        0.375,
      )} ${themeColor.shadow.secondary.default()}`;
    case Size.L:
      return `inset 0px 0px 0px ${themeSize.units(
        0.5,
      )} ${themeColor.shadow.secondary.default()}`;
    case Size.XL:
      return `inset 0px 0px 0px ${themeSize.units(
        0.8,
      )} ${themeColor.shadow.secondary.default()}`;
    case Size.XXL:
      return `inset 0px 0px 0px ${themeSize.units(
        1,
      )} ${themeColor.shadow.secondary.default()}`;
    case Size.XXXL:
      return `inset 0px 0px 0px ${themeSize.units(
        1.6,
      )} ${themeColor.shadow.secondary.default()}`;
    default:
      return `inset 0px 0px 0px ${themeSize.units(
        0.375,
      )} ${themeColor.shadow.secondary.default()}`;
  }
};

export const WorkspaceAvatarWrapper = styled.div(() => ({}));

export const Wrapper = styled.div(({ theme: { size } }) => ({
  position: 'relative',
  display: 'inline-flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '50%',

  [WorkspaceAvatarWrapper]: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    marginRight: size.units(-0.5),
    marginBottom: size.units(-0.5),
  },
}));

type WrapperStyledProps = {
  $size: Size;
  $hasImage: boolean;
};

export const ImageWrapper = styled.div<WrapperStyledProps>(
  ({ $size, $hasImage, theme: { size, color } }) => ({
    minWidth: getSize($size, size),
    minHeight: getSize($size, size),
    width: getSize($size, size),
    height: getSize($size, size),
    borderRadius: '50%',
    overflow: 'hidden',
    backgroundColor: $hasImage ? 'transparent' : color.background.tertiary.default(),
  }),
);

export const UserAvatarImage = styled(Image)(
  ({ $src, $size, theme: { color, size } }) => ({
    borderRadius: '50%',
    backgroundSize: $src ? 'cover' : getSize($size, size),
    boxShadow: !$src ? getBoxShadow(size, color, $size) : undefined,
  }),
);
